module.exports = __webpack_public_path__ + "static/media/navigation.dc97da98.svg";